import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { api, apiError } from "../../lib/api";
import { formatARS } from "../../lib/site";

export const MoveBooking = ({ booking, isAdmin, onClose, onDone }) => {
  const [d, setD] = useState(null);
  const [target, setTarget] = useState("");
  const [payment, setPayment] = useState("efectivo");
  const [waive, setWaive] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!booking) return undefined;
    setD(null); setWaive(false);
    api.get(`/admin/bookings/${booking.id}/move-options`).then((r) => { setD(r.data); setTarget(r.data?.options?.find((o) => o.missing === 0)?.id ?? ""); })
      .catch((e) => { toast.error(apiError(e)); onClose(); });
    return undefined;
  }, [booking]); // eslint-disable-line react-hooks/exhaustive-deps
  const fee = waive ? 0 : d?.fee?.amount ?? 0;
  const charge = fee > 0 && d?.booking?.status === "confirmado";
  const go = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/bookings/${booking.id}/move`, { target_trip_id: target, waive, payment: charge ? payment : null });
      toast.success(`Pasaje ${data.booking.code} movido al ${data.booking.date} ${data.booking.departure} hs${data.fee ? ` · cargo ${formatARS(data.fee)}` : ""}`);
      onDone();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={Boolean(booking)} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="move-booking-dialog" className="max-w-lg rounded-3xl">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Cambiar de horario</DialogTitle>
          <DialogDescription>{booking?.code} · {booking?.name} · butacas {booking?.seats?.join(", ")}</DialogDescription>
        </DialogHeader>
        {!d ? <Loader2 className="h-5 w-5 animate-spin" /> : (
          <div className="space-y-3">
            <p data-testid="move-fee" className={`rounded-xl p-3 text-sm ${d.fee?.amount ? "bg-amber-100 text-amber-950" : "bg-[var(--lime)]/40"}`}>{d.fee?.reason}{d.fee?.amount ? ` · cargo ${formatARS(d.fee.amount)}${d.booking.status === "reservado" ? " (se suma a la reserva)" : ""}` : ""}</p>
            {d.options?.length ? (
              <select data-testid="move-target" value={target} onChange={(e) => setTarget(e.target.value)} className="h-11 w-full min-w-0 rounded-xl border border-black/10 bg-white px-3">
                <option value="">Elegí el nuevo horario</option>
                {d.options.map((o) => <option key={o.id} value={o.id} disabled={o.missing > 0}>{o.date} · {o.departure} hs · Int. {o.unit ?? "—"} · {o.missing ? "sin lugar" : o.changed_seats ? "otra butaca" : "misma butaca"}</option>)}
              </select>
            ) : <p data-testid="move-empty" className="text-sm">No hay otros horarios futuros de esta ruta con unidad.</p>}
            {isAdmin && d.fee?.amount > 0 && <label className="flex items-center gap-2 text-sm"><input type="checkbox" data-testid="move-waive" checked={waive} onChange={(e) => setWaive(e.target.checked)} /> Hacer el cambio sin cargo</label>}
            {charge && (
              <select data-testid="move-payment" value={payment} onChange={(e) => setPayment(e.target.value)} className="h-11 w-full rounded-xl border border-black/10 bg-white px-3">
                <option value="efectivo">Cobro el cargo en efectivo</option><option value="tarjeta">Cobro el cargo con tarjeta</option><option value="transferencia">Cobro el cargo por transferencia</option>
              </select>
            )}
            <button onClick={go} disabled={busy || !target} data-testid="move-confirm" className="inline-flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-[var(--forest)] font-bold text-white disabled:opacity-40">
              {busy && <Loader2 className="h-4 w-4 animate-spin" />} {charge ? `Cobrar ${formatARS(fee)} y cambiar` : "Cambiar y avisar por email"}
            </button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
